import React from "react";
import { Modal, Button } from "react-bootstrap";
import * as actions from "../../../../redux/actions/verification";
import { useDispatch, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export default function IdentityVerificationDialog({
  id,
  show,
  onHide,
  row,
  verificationToken,
  profile,
}) {
  const STATUS = {
    verified: "verified",
    resend: "resend",
    rejected: "rejected",
  };
  const dispatch = useDispatch();
  const { actionsLoading } = useSelector((state) => ({
    actionsLoading: state.verification.actionsLoading,
  }));

  const handleAcceptVerification = (e) => {
    e.preventDefault();
    let body;
    switch (e.target.id) {
      case "accept":
        body = { status: STATUS.verified };
        break;
      case "askagain":
        body = { status: STATUS.resend };
        break;
      case "deny":
        body = { status: STATUS.rejected };
        break;
      default:
        break;
    }
    dispatch(actions.actionIdentityVerification(row.id, body));
    onHide();
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header>
        <div className="d-flex justify-content-left col-6">
          {row?.picture?.url && "Identity verification"}
          {row?.url && "Media - Preview"}
        </div>
        <div className="d-flex justify-content-end col-6">
          {row?.code ? `Code: ${row?.code}` : `ID: ${row?.id}`}
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-center">
          {row?.ext === ".mp4" ? (
            <div className="player-wrapper">
              <video width="320" height="240" controls>
                <source src={row?.url + verificationToken} type="video/mp4" />
              </video>
            </div>
          ) : (
            <img
              style={{ height: "500px" }}
              alt=""
              src={
                profile
                  ? profile.restless_user?.picture?.url + verificationToken
                  : (row?.picture?.url || row?.url) + verificationToken
              }
            />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="container row">
          {row?.picture?.url && (
            <>
              <div
                className={
                  "d-flex justify-content-left col-6" +
                  `${row.url ? "col-12" : ""}`
                }
              >
                <Button
                  id="accept"
                  className="btn btn-primary"
                  onClick={handleAcceptVerification}
                >
                  Accept
                  {actionsLoading ? (
                    <span className="mx-3 spinner spinner-white"></span>
                  ) : (
                    <span className="svg-icon ml-2 mr-0">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Navigation/Check.svg"
                        )}
                      />
                    </span>
                  )}
                </Button>
                <Button
                  id="askagain"
                  className="btn btn-warning mx-2"
                  onClick={handleAcceptVerification}
                >
                  Ask again
                  {actionsLoading ? (
                    <span className="mx-3 spinner spinner-white"></span>
                  ) : (
                    <span className="svg-icon ml-2 mr-0">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Update.svg"
                        )}
                      />
                    </span>
                  )}
                </Button>
                <Button
                  id="deny"
                  className="btn btn-danger"
                  onClick={handleAcceptVerification}
                >
                  Deny
                  {actionsLoading ? (
                    <span className="mx-3 spinner spinner-white"></span>
                  ) : (
                    <span className="svg-icon ml-2 mr-0">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Navigation/Close.svg"
                        )}
                      />
                    </span>
                  )}
                </Button>
              </div>
              <div className="d-flex justify-content-end col-6">
                <Button className="btn btn-secondary" onClick={onHide}>
                  Cancel
                </Button>
              </div>
            </>
          )}
          {row?.url && (
            <div className="d-flex justify-content-end col-12">
              <Button className="btn btn-secondary" onClick={onHide}>
                Cancel
              </Button>
            </div>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
}
